import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const nav = [
  { section: 'Main' },
  { to: '/dashboard', icon: '📊', label: 'Dashboard', roles: ['Administrator','Finance','Meter Reader','Customer Service','Store Keeper','Technician'] },
  { section: 'Customers' },
  { to: '/customers', icon: '👥', label: 'Customers', roles: ['Administrator','Finance','Customer Service'] },
  { to: '/meters', icon: '💧', label: 'Meters', roles: ['Administrator','Finance','Meter Reader','Customer Service'] },
  { section: 'Billing' },
  { to: '/billing', icon: '📋', label: 'Meter Readings', roles: ['Administrator','Finance','Meter Reader'] },
  { to: '/invoices', icon: '🧾', label: 'Invoices', roles: ['Administrator','Finance','Customer Service'] },
  { to: '/connection-fees', icon: '🔌', label: 'Connection Fees', roles: ['Administrator','Finance'] },
  { section: 'Finance' },
  { to: '/payments', icon: '💳', label: 'Payments', roles: ['Administrator','Finance'] },
  { to: '/credit-notes', icon: '📝', label: 'Credit Notes', roles: ['Administrator','Finance'] },
  { to: '/debit-notes', icon: '📌', label: 'Debit Notes', roles: ['Administrator','Finance'] },
  { to: '/disconnections', icon: '🚫', label: 'Disconnections', roles: ['Administrator','Finance'] },
  { section: 'Operations' },
  { to: '/maintenance', icon: '🔧', label: 'Maintenance', roles: ['Administrator','Technician','Customer Service'] },
  { to: '/inventory', icon: '📦', label: 'Inventory', roles: ['Administrator','Store Keeper','Technician'] },
  { to: '/expenses', icon: '💰', label: 'Expenses', roles: ['Administrator','Finance'] },
  { to: '/petty-cash', icon: '🪙', label: 'Petty Cash', roles: ['Administrator','Finance'] },
  { section: 'NRW' },
  { to: '/nrw/sources', icon: '🌊', label: 'Water Sources', roles: ['Administrator','Data Entry'] },
  { to: '/nrw/source-readings', icon: '📊', label: 'Source Readings', roles: ['Administrator','Data Entry'] },
  { to: '/nrw/tanker-deliveries', icon: '🚛', label: 'Tanker Deliveries', roles: ['Administrator','Data Entry','Finance'] },
  { to: '/nrw/tanks', icon: '🏗', label: 'Storage Tanks', roles: ['Administrator'] },
  { to: '/nrw/tank-readings', icon: '📏', label: 'Tank Readings', roles: ['Administrator','Data Entry'] },
  { to: '/nrw/report', icon: '📉', label: 'NRW Report', roles: ['Administrator','Finance'] },
  { section: 'Accounts' },
  { to: '/accounting', icon: '📒', label: 'GL Accounts', roles: ['Administrator','Finance'] },
  { to: '/accounting/journals', icon: '📝', label: 'Journal Entries', roles: ['Administrator','Finance'] },
  { section: 'Reports' },
  { to: '/reports/aged-analysis', icon: '📅', label: 'Aged Analysis', roles: ['Administrator','Finance'] },
  { to: '/reports/overpayments', icon: '💰', label: 'Overpayments', roles: ['Administrator','Finance','Customer Service'] },
  { to: '/reports/account-balances', icon: '👥', label: 'Account Balances', roles: ['Administrator','Finance'] },
  { to: '/reports/consumption', icon: '💧', label: 'Consumption Report', roles: ['Administrator','Finance','Customer Service'] },
  { to: '/reports/statements', icon: '📄', label: 'Statements', roles: ['Administrator','Finance','Customer Service'] },
  { to: '/reports/trial-balance', icon: '⚖️', label: 'Trial Balance', roles: ['Administrator','Finance'] },
  { to: '/reports/gl-detail', icon: '📒', label: 'GL Account Detail', roles: ['Administrator','Finance'] },
  { to: '/reports/fixed-assets', icon: '🏗️', label: 'Fixed Assets', roles: ['Administrator','Finance'] },
  { to: '/reports/income-statement', icon: '📊', label: 'Income Statement (P&L)', roles: ['Administrator','Finance'] },
  { to: '/reports/balance-sheet', icon: '🏦', label: 'Balance Sheet', roles: ['Administrator','Finance'] },
  { to: '/reports/revenue', icon: '📈', label: 'Revenue', roles: ['Administrator','Finance'] },
  { to: '/reports/by-location', icon: '📍', label: 'By Location', roles: ['Administrator','Finance'] },
  { section: 'System' },
  { to: '/settings', icon: '⚙️', label: 'Settings', roles: ['Administrator'] },
  { to: '/users', icon: '👤', label: 'Users', roles: ['Administrator'] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  // Filter nav items by user role
  const visibleNav = nav.filter(item => {
    if (item.section) return true; // always show section headers initially
    return item.roles && item.roles.includes(user?.role);
  });

  // Remove section headers that have no items following them
  const filteredNav = visibleNav.filter((item, index) => {
    if (!item.section) return true;
    // Check if next visible item is also a section or end of array
    const nextItem = visibleNav[index + 1];
    return nextItem && !nextItem.section;
  });

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>💧 WaterBill</h1>
        <span>Management System</span>
      </div>
      <nav style={{flex:1,padding:'8px 0'}}>
        {filteredNav.map((item, i) => {
          if (item.section) return <div key={i} className="sidebar-section">{item.section}</div>;
          return (
            <NavLink key={item.to} to={item.to} className={({isActive}) => 'sidebar-item' + (isActive?' active':'')}>
              <span>{item.icon}</span><span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      <div className="sidebar-bottom">
        <div style={{padding:'8px 12px',marginBottom:'4px'}}>
          <div style={{fontSize:12,color:'#94a3b8'}}>Logged in as</div>
          <div style={{fontSize:13,color:'#fff',fontWeight:500}}>{user?.full_name}</div>
          <div style={{fontSize:11,color:'#64748b'}}>{user?.role}</div>
        </div>
        <button onClick={handleLogout} className="sidebar-item" style={{width:'100%',border:'none',background:'none',cursor:'pointer',color:'#ef4444'}}>
          <span>🚪</span><span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
